const circle = require('@turf/circle').default;

/**
 * Parse existing geofence data format to GeoJSON feature objects that Mapbox understands.
 *
 * @param shape
 * @returns {{geometry: {coordinates: *[], type: string}, type: string, properties: {shape: string}}|{geometry: {coordinates: *[][][], type: string}, type: string, properties: {shape: string}}|Feature<Polygon, GeoJsonProperties>}
 */
exports.parseOldGeofenceShape = shape => {
    const type = shape.type;

    if (type === 'circle') {
        const radius = shape.radius / 1000; // Convert radius from M to KM, Turf needs KM
        const center = shape.center;

        let feature = circle([center.lng, center.lat], radius);
        feature['id'] = 'geofence';
        feature['properties']['shape'] = 'circle';
        feature['properties']['center'] = [center.lng, center.lat];
        feature['properties']['radius'] = radius;

        return feature;
    } else if (type === 'rectangle') {
        const coords = shape.coords;
        const northEast = coords.northeast;
        const southWest = coords.southwest;

        return {
            id: 'geofence',
            type: 'Feature',
            geometry: {
                coordinates: [
                    [
                        [southWest.lng, northEast.lat],
                        [northEast.lng, northEast.lat],
                        [northEast.lng, southWest.lat],
                        [southWest.lng, southWest.lat],
                        [southWest.lng, northEast.lat],
                    ],
                ],
                type: 'Polygon',
            },
            properties: {
                shape: 'rectangle',
            },
        };
    } else if (type === 'polygon') {
        return {
            id: 'geofence',
            type: 'Feature',
            geometry: {
                coordinates: [shape.coords.map(obj => [obj.lng, obj.lat])],
                type: 'Polygon',
            },
            properties: {
                shape: 'polygon',
            },
        };
    }
};

/**
 * Convert GeoJson feature object back to the old Geofence format used by VRM.
 *
 * Mapbox doesn't know the concept of a rectangle, it handles it like any other polygon, so we convert it to the
 * old polygon object format.
 *
 * @param shape
 * @returns {{type: *, coords: *[]}|{center: {lng: *, lat: *}, type: *, radius: number}}
 */
exports.convertToOldGeofenceShape = shape => {
    if (shape.properties.shape === 'circle') {
        return {
            id: 'geofence',
            type: 'circle',
            radius: shape.properties.radius * 1000,
            center: {
                lng: shape.properties.center[0],
                lat: shape.properties.center[1],
            },
        };
    }

    return {
        id: 'geofence',
        type: 'polygon',
        coords: shape.geometry.coordinates[0].map(coord => {
            return {
                lng: coord[0],
                lat: coord[1],
            };
        }),
    };
};
